import { inject, Injectable } from '@angular/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { SnackService } from './snack.service';

@Injectable({
    providedIn: 'root'
})
export class ClipboardService {
    private clipboard = inject(Clipboard);
    private snackService = inject(SnackService);

    public async copyToClipboard(data: string): Promise<void> {
        const copySuccessfull = this.clipboard.copy(data);

        if (copySuccessfull) {
            this.showSuccessSnack();
        } else {
            try {
                const clipboardPermission = await navigator.permissions.query({ name: 'clipboard-read' as PermissionName });

                if (clipboardPermission.state === 'denied') {
                    this.showErrorSnack();

                    return;
                }

                await navigator.clipboard.writeText(data);

                this.showSuccessSnack();
            } catch {
                this.showErrorSnack();
            }
        }
    }

    private showSuccessSnack(): void {
        this.snackService.success({
            headline: 'Copied to clipboard',
            text: 'The data has been copied to your clipboard',
        });
    }

    private showErrorSnack(): void {
        this.snackService.error({
            'headline': 'Missing permission',
            'text': 'Please allow clipboard access for this website through your browser settings',
        });
    }
}

